const initialvalues = {
    DistList: [],
    mandalList: [],
    villageList: [],
    habitationList: [],
    collNatureLIST: [],
    religionList: [],
    casts: [],
    designations: [],
    empTypes: [],
    qualifications: [],
    courses: [],
    coursesFlags: [],
    DesignationList: [],
    subList: [],
    Deptlist: [],
    Medium: [],
    CollegeCode: '',
    Status: [],
    LoginDates: [],
    CollegeType: '',
    DistListsAtMultiField: [],
    mandalListAtMultiField: [],
    villageListAtMultiField: [],
    ffcaStatus: '',
    scemewiseDistrictData: [],

};


export default function CommonMastersReducer(details = initialvalues, action) {
    switch (action.type) {
        case "DISTRICTLIST":
            return { ...details, DistList: action.payload };
        case "VILLAGESLIST":
            return { ...details, villageList: action.payload };
        case "MANDALSLIST":
            return { ...details, mandalList: action.payload };
        case "HabitationLIST":
            return { ...details, habitationList: action.payload };
        case "CollNatureLIST":
            return { ...details, collNatureLIST: action.payload };
        case "ReligionList":
            return { ...details, religionList: action.payload };
        case "Casts":
            return { ...details, casts: action.payload };
        case "Designations":
            return { ...details, designations: action.payload };
        case "EmpTypes":
            return { ...details, empTypes: action.payload };
        case "Qualifications":
            return { ...details, qualifications: action.payload };
        case "Courses":
            return { ...details, courses: action.payload };

        case "Coursesflags":
            return { ...details, coursesFlags: action.payload };
        case "DisignationList":
            return { ...details, DesignationList: action.payload };
        case "SubList":
            return { ...details, subList: action.payload };
        case "DepartmentList":
            return { ...details, Deptlist: action.payload };
        case "MEDIUM":
            return { ...details, Medium: action.payload };
        case "COLLEGE_CODE":
            return { ...details, CollegeCode: action.payload };
        case "STATUS":
            return { ...details, Status: action.payload };
        case "LoginDates":
            return { ...details, LoginDates: action.payload };
        case "COLLEGETYPE":
            return { ...details, CollegeType: action.payload };

        case "MANDALSLIST_MultiField":
            return { ...details, mandalListAtMultiField: action.payload };

        case "DISTRICTLIST_MultiField":
            return { ...details, DistListsAtMultiField: action.payload };

        case "FFCA_STATUS":
            return { ...details, ffcaStatus: action.payload };
        case "SCHEMEWISE_DISTRICTS_DATA":
            return { ...details, scemewiseDistrictData: action.payload };


        case "VILLAGELIST_MultiField":

            return { ...details, villageListAtMultiField: action.payload };

        default:
            return details;
    }
}